'use client';
import { NestedSubCategory } from './nested-subcategories';

export const SubCategories = ({ subCategories = [] }) => {
  return subCategories.map(
    ({ name, seoURL, subCategories: subCategoriesList, ...rest }) => (
      <NestedSubCategory
        key={name}
        name={name}
        seoURL={seoURL}
        subCategories={subCategoriesList}
        {...rest}
      >
        {({ name, seoURL }) => (
          <NestedSubCategory
            key={name}
            name={name}
            seoURL={seoURL}
            className="ps-3"
            {...rest}
          />
        )}
      </NestedSubCategory>
    )
  );
};
